import React, { useEffect } from "react";
import BlockHowItWorks from "components/BlockHowItWorks";
import BlockPracticeAreas from "components/BlockPracticeAreas";
import BlockAbout from "./components/BlockAbout";
import BlockBookACoach from "./components/BlockBookACoach";
import BlockServicesLanding from "./components/BlockServicesLanding";
import BlockTestimonials from "./components/BlockTestimonials";
import BlockWhoWeHelp from "./components/BlockWhoWeHelp";
import BlockWhyCoaching from "./components/BlockWhyCoaching";
import BasePage from "../../components/BasePage";
import "./style.scss";

export default function PageLanding() {
  useEffect(() => {
    const main = document.querySelector(".main");
    main?.classList.add("bg-white");
    return () => main?.classList.remove("bg-white");
  }, []);

  return (
    <BasePage className="page-landing">
      <BlockAbout />
      <BlockWhyCoaching />
      <BlockServicesLanding />
      <BlockPracticeAreas />
      <BlockWhoWeHelp />
      <BlockHowItWorks />
      <BlockTestimonials />
      <BlockBookACoach />
    </BasePage>
  );
}
